<template>
  <div class="headerContent">
    <div class="header-logo">
      <div class="header-logo-Box">
        <img v-if="companyLogo !== ''" :src="companyLogo" :width="imgwidth" :height="imgheight" />
      </div>
    </div>
    <div v-if="multiPaper" class="header-menu">
      <ul>
        <li v-for="(itm, idx) in arrpaper" :key="idx">
          <a @click="setActiveIndex(idx)">
            <span :class="{active: curpaper === idx}">{{itm}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Header',
  props: ['companyLogo', 'imgwidth', 'imgheight'],
  data () {
    return {
    }
  },
  methods: {
    setActiveIndex: function (idx) {
      this.$store.commit('setCurrentPaper', {CurrentPaper: idx})
    }
  },
  computed: {
    curpaper: function () {
      return this.$store.state.CurrPaper
    },
    arrpaper: function () {
      return this.$store.state.PaperList
    },
    multiPaper: function () {
      return (this.$store.state.PaperList.length > 1)
    }
  }
}
</script>
  <style scoped>
  .headerContent {
    width: 100%;
    height: 60px;
    margin-top: 0;
    padding-top: 0;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    background-color: grey;
  }
  .header-logo {
    width: 120px;
  }
  .header-logo-Box {
    padding-left: 10px;
  }
  .header-menu {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 15px;
  }
  .header-menu ul {
    list-style-type: none;
    margin-left: 20px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 0;
    overflow: hidden;
    background: none;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 0;
  }
    @media screen and (max-width:720px) {
      .header-menu {
        font-size: 12px;
      }
    }
    @media screen and (max-width:425px) {
      .headerContent {
        height: 100%;
      }
      .header-menu ul {
        margin-left: 10px;
        margin-top: 10px;
        -webkit-flex-direction:column;
        -ms-flex-direction:column;
        flex-direction:column;
      }
      .header-menu{
        font-size: 13px;
      }
    }
  a {
    cursor:pointer;
  }
  .header-menu a {
    text-decoration: none;
    border-bottom: transparent solid 5px;
    display: block;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 0;
    color: white;
  }
  .header-menu a:hover,
  .header-menu a:focus {
    cursor: pointer;
  }
  .header-menu span:hover,
  .header-menu span:focus,
  .header-menu .active {
    color: #096ec6;
    border-bottom: white solid 3px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Header.vue